import { render } from "./FormSearchVoided.vue?vue&type=template&id=64bb1306&scoped=true"
import script from "./FormSearchVoided.vue?vue&type=script&lang=js"
export * from "./FormSearchVoided.vue?vue&type=script&lang=js"

import "./FormSearchVoided.vue?vue&type=style&index=0&id=64bb1306&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb1306"]])

export default __exports__